module.exports = __webpack_public_path__ + "assets/img/image2.b20df6b3.png";